(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vexali-compression-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vexali-gallery')) {
  customElements.define('vexali-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-src]');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.vexali-gallery__image');
        image.removeAttribute('srcset');
        image.src = button.dataset.gallerySrc;
        image.alt = button.dataset.galleryAlt || 'Vexali product image';
        this.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
